import { register } from '!/repository'
import { $popup } from './translations'

register($popup, '$popup')
